const startOfDay = (date: Date): Date => {
    const result = new Date(date);
    result.setHours(0, 0, 0, 0);
    return result;
};

/**
 * Builds the `absenceFrom` date with the appropriate time component:
 * - if the chosen day is today, the current time is used (the absence starts now)
 * - if the chosen day is in the future, the time is set to 00:00 so the absence
 *   covers the whole day instead of starting in the middle of it
 */
export const buildAbsenceFromDate = (date: Date, now: Date = new Date()): Date => {
    if (startOfDay(date).getTime() <= startOfDay(now).getTime()) {
        return new Date(now);
    }

    return startOfDay(date);
};

/**
 * Builds the `absenceUntil` date with the time fixed to 18:00 so the absence
 * always covers the chosen day until end of business hours.
 */
export const buildAbsenceUntilDate = (date: Date): Date => {
    const result = new Date(date);
    result.setHours(18, 0, 0, 0);
    return result;
};
